export default "__VITE_ASSET__Kq7GJbgQ__"